<div *ngIf="show">
  <div id="cover-bottom-sheet" (click)="clickedClose()">

  </div>
  <div id="content-bottom-sheet">
    <p id="title-bottom-sheet">
      {{ title }}
    </p>
    <p id="content-bottom-subtitle">{{ subtitle }}</p>
    <ng-content select="[content]"></ng-content>
  </div>
</div>